/*
 * @Author: Tina Huang
 * @Date: 2024-08-29 17:37:12
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2024-09-03 22:18:51
 * @Description:
 */
import { TypesKey } from '@/constants/creator'
import StarForm from './star'
import LuckinForm from './luckin'
import XichaForm from './xicha'
import ChaBaiDaoForm from './chabaidao'
import GoodMeForm from './goodme'

export default function ReceiptForm({ type }: any) {
  if (type === TypesKey.Starbucks) {
    return <StarForm />
  }
  if (type === TypesKey.Luckin) {
    return <LuckinForm />
  }
  if (type === TypesKey.Xicha) {
    return <XichaForm />
  }
  if (type === TypesKey.ChaBaiDao) {
    return <ChaBaiDaoForm />
  }
  if (type === TypesKey.GoodMe) {
    return <GoodMeForm />
  }

  return <></>
}
